<template>
	<el-descriptions style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top" title="申请信息" border>
		<el-descriptions-item v-if="biao.type">
			<template slot="label">
				<i class="el-icon-paperclip"></i>
				家庭经济状况
			</template>
			{{biao.type}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.ptype">
			<template slot="label">
				申请培训类别
			</template>
			{{biao.ptype}}
		</el-descriptions-item>
	<el-descriptions-item v-if="biao.peixun_content">
		<template slot="label">
			具体培训内容
		</template>
		{{biao.peixun_content}}
	</el-descriptions-item>
	<el-descriptions-item v-if="biao.peixun_ori">
		<template slot="label">
			之前参加的培训
		</template>
		{{biao.peixun_ori}}
	</el-descriptions-item>
	<el-descriptions-item v-if="biao.techang">
		<template slot="label">
			特长
		</template>
		{{biao.techang}}
	</el-descriptions-item>
	<el-descriptions-item v-if="biao.congye">
		<template slot="label">
			从业经历
		</template>
		{{biao.congye}}
	</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		computed:{
			
		},
		watch:{
			biao(){
			  	
			}
		},
		props:["biao"],
		created() {
			
		}
	}
</script>

<style>
</style>
